/** @format */

// lodash遍历对象的key键
import { keys, forEach } from 'lodash';
// mobx的公共方法
import { observable, action, useStrict, runInAction, autorun } from 'mobx';
// 请求路由配置项
import { getRouterTable } from './AppServ';
// 路由资源地址
import { routerList } from 'router/index';
import config from 'config/Config';
// 严格模式
useStrict(true);

class AppStore {
  // 监视状态
  @observable state = {
    isLoaded: true,
    routerCfg: {},
    hookCbf: null
  };

  // 自己的
  @observable
  iframeId = 'systemIframe';
  // 自己的

  // 构造函数
  constructor() {}

  // 设置路由配置
  @action setRouterCfg = async (list) => {
    // 请求路由表
    // let res = await getRouterTable();
    // 设置到状态机 - 如果是异步，必须在runInAction
    let routePathName = {};
    //先拿本地router的
    forEach(routerList, item => {
      routePathName[item.path] = { name: item.title };
      if(item.children && item.children.length){
        forEach(item.children, child =>{
          routePathName[child.path] = { name: (config.languageEnv == 'enUS' ? child.name_i1 || child.title : child.title)};
        })
      }
    });
    //再拿动态菜单的
    forEach(list, item => {
      routePathName[item.path] = { name: item.title };
    });
    runInAction(() => {
      this.state.routerCfg = routePathName;
    });
    // 监控数据变化的回调,读取什么参数，即代表将要监控什么数据
    autorun(() => {
      // console.info("router table is isLoaded: ", this.state.isLoaded);
    });
  };

  @action hideLoading = async () => {
    runInAction(() => {
      this.state.isLoaded = true;
    });
  };

  // 设置关闭页签钩子配置
  @action setCloseHook = hookCbf => {
    runInAction(() => {
      this.state.hookCbf = hookCbf;
    });
  };

  // 设置页签标题等内容
  @action setTabsInfo = titleObj => {
    let k = keys(titleObj)[0];
    runInAction(() => {
      this.state.routerCfg[k] = titleObj[k];
    });
  };

  @action
  setChildSystemLink(link) {
    this.childSystemLink = link;
  }
  @action
  setChildSystemApplicationKey(key) {
    this.childSystemApplicationKey = key;
  }

  sendMessage(data = {}) {
    let iframe = document.getElementById(this.iframeId);
    if (!iframe) return;
    iframe.contentWindow.postMessage(data, '*');
  }
}

const appStore = new AppStore();
export default appStore;
export { AppStore };



// WEBPACK FOOTER //
// ./src/widget/App/AppStore.js